import { Availability, getDefaultParticipant, Participant, Health, TopFriend } from "@turbo-schedule/common";
import { ArchiveYearToParticipantLabelToTextToSnapshotObj } from "@turbo-schedule/database";
import { UseFetchedStateReturn, createUseFetchedState } from "use-fetched-state";

/**
 * TODO: could be auto-generated from the express api :o
 */

export const fetchParticipantCore = [
	(participantName: string, snapshot?: string) => `/api/v1/participant/${encodeURIComponent(participantName)}${  !snapshot ? "" : `?snapshot=${snapshot}`}`,
	(data: UseFetchedStateReturn<{ participant: Participant }>[0]) => data.participant ?? getDefaultParticipant()
] as const;

// TODO FIXME
// @ts-expect-error
export const useFetchParticipant = createUseFetchedState<
	{ participant: Participant }, //
	Participant,
	string
>(
	...fetchParticipantCore
	// (participantName) => `/api/v1/participant/${encodeURIComponent(participantName)}`,
	// (data) => data.participant ?? getDefaultParticipant()
);

export type LessonlessP = Omit<Participant, "lessons">;
export type TextPreparedForSearching = { textPrepared: Fuzzysort.Prepared };
export type PreparedLessolessP = LessonlessP & TextPreparedForSearching;
export const useFetchParticipants = createUseFetchedState<
	{ participants?: LessonlessP[] }, //
	LessonlessP[]
>(
	"/api/v1/participant", //
	(data) => data?.participants ?? []
);

export const useFetchAvailability = createUseFetchedState<
	{ availability?: Availability[][] }, //
	Availability[][],
	{ wantedParticipantsString: string }
>(
	({ wantedParticipantsString }) =>
		`/api/v1/participant/common-availability?wanted-participants=${wantedParticipantsString}`, //
	(data) => data?.availability ?? []
);

export const useFetchHealth = createUseFetchedState<{ health: Health }, Health>(
	"/api/v1/health", //
	(data) => data.health
);

export const useFetchArchiveParticipantsInSnapshots = createUseFetchedState<{ data: ArchiveYearToParticipantLabelToTextToSnapshotObj }, ArchiveYearToParticipantLabelToTextToSnapshotObj>(
	"/api/v1/archive/participants-in-snapshots?group=schoolYear,label,text&leafItemKey=snapshot",
	(data) => data.data
);

export const useFetchTopFriend = createUseFetchedState<
	{ topFriend: TopFriend },
	TopFriend,
	{ of: string }
>(
	({ of }) => `/api/v1/statistics/top-friend/${of}`, //
	(data) => data.topFriend,
);

export const useFetchClassifyParticipant = createUseFetchedState<
	{ participants: Participant[] },
	Participant["labels"][0],
	string
>(
	(participant) => `/api/v1/participant/classify?participants=${participant}`, //
	(data) => data.participants[0].labels[0],
);
